@if(gpxStatsData()) {
  <div class="stat-list">
    <!--{{ gpxStatsData() | json }}-->
    <ul class="stat-list__items">
      
      @if(gpxStatsData()?.maxDistance) {
        <li class="stat-list__item">
          <p class="stat-list__title ci-paragraph-p3-semibold">
            {{ 'Distancia' | translate }}
          </p>
          
          <p class="stat-list__value ci-heading-h5-semibold">
            {{ gpxStatsData()?.maxDistance }} km
          </p>
        </li>
      } 
      
      @if(gpxStatsData()?.maxElevation) {
        <li class="stat-list__item">
          <p class="stat-list__title ci-paragraph-p3-semibold">
            {{ 'Máxima altitud' | translate }}
          </p>
          
          <p class="stat-list__value ci-heading-h5-semibold">
            {{ gpxStatsData()?.maxElevation }} m
          </p>
        </li>
      }
      
      @if(gpxStatsData()?.minElevation) {
        <li class="stat-list__item">
          <p class="stat-list__title ci-paragraph-p3-semibold">
            {{ 'Mínima altitud' | translate }}
          </p>
          
          <p class="stat-list__value ci-heading-h5-semibold">
            {{ gpxStatsData()?.minElevation }} m
          </p>
        </li>
      }
    </ul>

  </div>
}
